interface Loop {
  add: <T extends () => void>(
    newTask: T,
    option: {
      delay: (() => number) | number
      group?: string
    },
  ) => void
}
interface Task {
  deadline: number
  delay: (() => number) | number
  execute: () => void
  group: null | string
  startTime: number
}

export function useLoop(): Loop {
  const stack: Task[] = []

  function add<T extends () => void>(
    newExecute: T,
    option: {
      delay: (() => number) | number
      group?: string
    },
  ): void {
    function loop(): void {
      if (stack.length === 0) {
        return
      }

      const now = Date.now()
      for (let i = stack.length - 1; i >= 0; i--) {
        const task = stack[i]
        if (!task) {
          continue
        }
        if (typeof task.delay === 'function') {
          task.deadline = task.startTime + secondToMillisecond(task.delay())
        }
        if (task.deadline < now) {
          task.execute()
          stack.splice(i, 1)
        }
      }

      if (stack.length > 0) {
        requestAnimationFrame(loop)
      }
    }

    const delay = typeof option.delay === 'function' ? option.delay() : option.delay
    const deadline = Date.now() + secondToMillisecond(delay)

    const firstTask = stack[0]
    if (firstTask !== undefined && firstTask.group !== option.group) {
      firstTask.execute()
    }

    stack.push({
      deadline,
      delay: option.delay,
      execute: newExecute,
      group: option.group ?? null,
      startTime: Date.now(),
    })

    if (stack.length <= 1) {
      loop()
    }
  }

  return { add }
}
